let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("0577e")).then(() => parcelRequire('aHUge'));